import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, ButtonBase } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import DialogCloseButton from '../buttons/DialogCloseButton';

const styles = theme => ({
    googleButton: {
        backgroundImage: 'url(https://specterr.b-cdn.net/btn_google_signin_light_normal_web@2x.png)',
        backgroundSize: '191px 46px',
        width: 191,
        height: 46
    }
});

class ThirdPartyAuthDialog extends React.Component {
    state = {
    }

    render() {
        const { classes, title, open, onClose} = this.props;

        return (
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth='xs'
                aria-labelledby='third-party-auth-dialog-title'
            >
                <DialogTitle id='third-party-auth-dialog-title'>
                    {title}
                    <DialogCloseButton
                        onClick={onClose}
                    />
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        direction='column'
                        justifyContent='center'
                        alignItems='center'
                    >
                        <Grid>
                            <ButtonBase
                                className={classes.googleButton}
                                onClick={this.onGoogleClick}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Dialog>
        );
    }

    onGoogleClick = () => {
        const { googleAuthUrl, onClose } = this.props;

        window.open(googleAuthUrl);
        onClose();
    }
}

export default withStyles(ThirdPartyAuthDialog, styles);